import TemplateName, { TemplateNameProps } from './TemplateName';

export type { TemplateNameProps };
export default TemplateName;
